import { Flex,Text,Stack,Image,useColorMode } from "@chakra-ui/react"
export default function EmptyPocs({message}){
const {colorMode}=useColorMode();
    return (
<>
<Stack position={"relative"} alignItems="center" py="10px">
          <Image src={"/images/search_not_found.png"} alt='Search not found' height="200px" />
          <Text
              color={colorMode==='light'?"#000000":'white'}
          fontWeight={500}
          fontSize={"20px"}
          textAlign={"center"}
        >
          {message}
        </Text>
        
      </Stack>
</>
    )
}